import React from "react";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import addNewIcon from "../../../../../assets/SVGs/add.svg";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../../disability/DisabilityDashboard/styles/disbilityDashboardStyle.css";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const DivorceContactCard = ({
  step,
  fileUpload,
  loading,
  documents,
  moduleData,
  width,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const detailList = [
    {
      name: "Marriage Date",
      email: "test@gmail.com",
    },
    { name: "Separation Date", email: "test@gmail.com" },
  ];

  return (
    <div
      className="DisabilityCardMain"
      style={{
        position: "relative",
        width: width ? width : "",
        height: " 100%",
      }}
    >
      <div className="cardHeadingDisability">
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {moduleData.Icon && (
            <img
              width={66}
              height={56}
              src={moduleData.Icon}
              alt={moduleData.name}
            ></img>
          )}
          {/* {moduleData.name} */}
          <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
            {moduleData.name}
            {moduleData &&
              moduleData.tooltip &&
              ["Professional Contacts"].includes(moduleData.name) && (
                <ToolTipCreator name={moduleData.tooltip} />
            )}
          </div>          
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/divorce");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      {moduleData.Purpose && (
        <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      )}
      <div
        style={{ maxHeight: "10rem", overflowY: "auto", paddingInline: "8px" }}
      >
        {documents && documents.length > 0
          ? documents.map((item, index) => (
              <div key={index} className="disabilityDashboardListingRow">
                <div
                  className="checkListName"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <div>{item["Name"] ? item["Name"] : "N/A"}</div>
                  <div>{item.email ? item.email : "N/A"}</div>
                </div>
                <div
                  className="emailStatus"
                  style={{ background: "transparent", width: "fit-content" }}
                >
                  <img src={addNewIcon} alt="addNew"></img>
                </div>
              </div>
            ))
          : "No Data To Show"}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
